import { alpha } from '@mui/material';
import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  countryDrawer: {
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'flex-start',
      backgroundColor: alpha(theme.palette.cinnamon.main, 0.5),
    },
  },

  mainConatiner: {
    width: '100%',
    height: '100vh',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    paddingBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'scroll',
    [theme.breakpoints.up('sm')]: {
      width: '435px',
    },
    [theme.breakpoints.up('md')]: {
      width: '535px',
    },
  },

  headerContainer: {
    width: '100%',
    padding: '35px 30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  countryListContainer: {
    width: '190px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    rowGap: '25px',
    [theme.breakpoints.up('sm')]: {
      width: '300px',
      rowGap: '36px',
    },
  },

  countryContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '10px',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      columnGap: '45px',
    },
  },
});
